import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";

const Deleverytime = ({selectedDate,setSelectedDate,selectedOption,setSelectedOption,selectedMorTime,setSelectedMortime,selectedEveTime,setSelectedEvetime}) => {
 
  const [showPicker, setShowPicker] = useState(false);
  const calendarRef = useRef(null);

  
  
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdown1, setShowDropdown1] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setShowDropdown(false); 
  };
  const handleOptionSelect1 = (option) => {
    setSelectedMortime(option);
    setShowDropdown1(false); 
    setShowDropdown2(false); 
  };
  const handleOptionSelect2 = (option) => {
    setSelectedEvetime(option);
    setShowDropdown1(false);
    setShowDropdown2(false); 
  };
  const formatDate = (date) => {
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);
  const dropdownRef = useRef(null);
  const dropdown1Ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target )
      ) {
        setShowDropdown(false);
      }
      if (
        dropdown1Ref.current &&
        !dropdown1Ref.current.contains(event.target )
      ) {
        setShowDropdown1(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div className="w-full flex flex-col">
      <div className="w-full">
        <span className="text-textColor font-semibold text-base title1">
          Pre Order Delivery Time
        </span>
      </div>

      <div className="mt-4 bg-[#F6F7F3] rounded-2xl px-4 py-4 flex flex-col">
        <div className=" flex flex-col md:flex-row gap-1 md:gap-4 justify-between items-center cursor-pointer relative ">
          <MdOutlineCalendarMonth className="text-3xl text-[#5D6D56]" />

          <input
            type="text"
            className="w-full px-2 py-2 bg-[#F6F7F3]"
            placeholder="Enter Couple Code"
            value={selectedDate ? formatDate(selectedDate) : ""}
            readOnly
            required
           
          />

          {showPicker && (
            <div className="absolute top-full mt-2 z-10" ref={calendarRef}>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => {
                  setSelectedDate(date);
                  setShowPicker(false);
                }}
                inline
                minDate={new Date()}
              />
            </div>
          )}

          <button
            className="bg-textColor text-white px-8 flex items-center justify-center py-3 md:py-1 rounded-xl w-full md:w-20"
            onClick={() => {
              if (selectedDate) {
                setSelectedDate(null);
              } else {
                setShowPicker(true);
              }
            }}
          >
            {selectedDate ? "Remove" : "Select"}
          </button>
        </div>
        <div className="w-full px-4 py-4 flex gap-10">
          <div className="flex flex-col items-center w-1/2 bg-Background2 py-2 rounded-xl relative"  ref={dropdownRef}>
            <div
              className="flex gap-12 items-center w-full justify-center cursor-pointer"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <span className="text-textColor font-semibold">{selectedOption}</span>
              <MdKeyboardArrowDown className="text-[#505f49] text-2xl"/>
            </div>

            {showDropdown && (
              <div className="absolute top-full mt-2 w-full bg-white shadow-lg rounded-xl z-50">
                <ul>
                  <li
                    className="px-4 py-2 cursor-pointer hover:bg-Background2 text-textColor font-semibold"
                    onClick={() => handleOptionSelect("Morning")}
                  >
                    Morning
                  </li>
                  <li
                    className="px-4 py-2 cursor-pointer hover:bg-Background2 text-textColor font-semibold"
                    onClick={() => handleOptionSelect("Evening")}
                  >
                    Evening
                  </li>
                </ul>
              </div>
            )}
          </div>
         {selectedOption == "Morning" ?
          <div className="flex flex-col items-center w-1/2 bg-Background2  py-2 rounded-xl relative" ref={dropdown1Ref}>
            <div
              className="flex gap-12 items-center w-full justify-center cursor-pointer"
              onClick={() => setShowDropdown1(!showDropdown1)}
            >
              <span className="text-textColor font-semibold">{selectedMorTime}</span>
              <MdKeyboardArrowDown className="text-[#505f49] text-2xl"/>
            </div>

            {showDropdown1 && (
              <div className="absolute top-full mt-2 w-full bg-white shadow-lg rounded-xl z-50">
                <ul>
                  <li
                    className="px-3 py-2 cursor-pointer hover:bg-Background2 text-textColor font-semibold"
                    onClick={() => handleOptionSelect1("6 am to 8am")}
                  >
                    6 am to 8 am
                  </li>
                  <li
                    className="px-3 py-2 cursor-pointer hover:bg-Background2 text-textColor font-semibold"
                    onClick={() => handleOptionSelect1("8 am to 10 am")}
                  >
                    8 am to 10 am
                  </li>
                </ul>
              </div>
            )}
          </div> :
          <div className="flex flex-col items-center w-1/2 bg-Background2 py-2 rounded-xl relative" ref={dropdown1Ref}>
            <div
              className="flex gap-12 items-center w-full justify-center cursor-pointer"
              onClick={() => setShowDropdown2(!showDropdown2)}
            >
              <span className="text-textColor font-semibold">{selectedEveTime}</span>
              <MdKeyboardArrowDown />
            </div>

            {showDropdown2 && (
              <div className="absolute top-full mt-2 w-full bg-white shadow-lg rounded-xl z-50">
                <ul>
                  <li
                    className="px-4 py-2 cursor-pointer hover:bg-Background2 text-textColor font-semibold"
                    onClick={() => handleOptionSelect2("6 pm to 8 pm")}
                  >
                    6 pm to 8 pm
                  </li>
                  <li
                    className="px-4 py-2 cursor-pointer hover:bg-Background2 text-textColor font-semibold"
                    onClick={() => handleOptionSelect2("8 pm to 10 pm")}
                  >
                    8 pm to 10 pm
                  </li>
                </ul>
              </div>
            )}
          </div> }
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Deleverytime;
